import { createFileRoute } from "@tanstack/react-router"
import emailVerifier from "modules/backoffice/components/emailVerifier"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/emailVerifier")({
  component: emailVerifier,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.emailVerifier.title"),
    })
  },
})
